module.exports = "/_next/static/images/birthday-11d2b59bebac468968d2befeb44bcdaa.png";